import { takeEvery, put } from 'redux-saga/effects'
import { CREATE_SUCCESS, UPDATE_SUCCESS } from '@/state/types/data'
import { goToPage } from '@/state/actions/routes'

function* redirectTo(action) {
  // Rendering
  yield put(
    goToPage(action.meta.redirectTo.type, null, { id: action.payload.data.id, step: 'build' }),
  )
}

export default function* redirectNewBuild(action) {
  yield takeEvery(
    action =>
      (action.type === CREATE_SUCCESS || action.type === UPDATE_SUCCESS) &&
      action.meta &&
      action.meta.redirectTo,
    redirectTo,
  )
}



// WEBPACK FOOTER //
// ./state/sagas/build.js